import { render, staticRenderFns } from "./EmployeeRegister.vue?vue&type=template&id=744d8c36&scoped=true&"
import script from "./EmployeeRegister.vue?vue&type=script&lang=js&"
export * from "./EmployeeRegister.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRegister.vue?vue&type=style&index=0&id=744d8c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d8c36",
  null
  
)

export default component.exports